import React, { useContext, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

import AuthContext from 'router/AuthContext';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import logo from 'assets/img/dohwa.png';
import { useNavigate } from 'react-router-dom';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.dohwa.co.kr/">
        DOHWA ENGINEERING
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function LogIn() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'all',
    defaultValues: {
      id: '',
      password: ''
    }
  });

  let auth = useContext(AuthContext);

  let userPwInput = useRef(null);

  const [error, setError] = useState(false);

  const signIn = (data) => {
    const userId = data.id;
    const password = data.password;
    auth.signin({ userId, password }, (result) => {
      if (result?.status === 401) {
        userPwInput.current.focus();
        setError(true);
      }
    });
  };

  const onSubmit = async (data) => {
    await signIn(data);
  };

  const handleJoin = () => {
    navigate('/join');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      signIn();
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Box component="img" src={logo} sx={{ m: 2, p: 2, witdh: 120, height: 120 }} />
          <Typography component="h1" variant="h5">
            도화 앱스 (Dohwa Apps)
          </Typography>
          <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              id="id"
              label="ID"
              name="id"
              autoFocus
              error={!!errors.id}
              helperText={errors.id && errors.id.message}
              {...register('id', {
                required: 'ID를 입력해주세요.'
              })}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="비밀번호"
              type="password"
              id="password"
              onKeyPress={handleKeyPress}
              inputRef={userPwInput}
              error={!!errors.password}
              helperText={errors.password && errors.password.message}
              {...register('password', {
                required: '비밀번호를 입력해주세요.'
              })}
            />
            {/*<Typography variant="button" display="block" align="center">*/}
            {/*  id 찾기 / 비밀번호 찾기*/}
            {/*</Typography>*/}
            {error && (
              <Typography variant="button" display="block" gutterBottom sx={{ mt: 3, color: 'red' }}>
                아이디 또는 비밀번호가 잘못 입력 되었습니다.
                <br />
                아이디와 비밀번호를 정확히 입력해 주세요.
              </Typography>
            )}
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              로그인
            </Button>

            <Button fullWidth variant="contained" color={'success'} onClick={handleJoin}>
              회원가입
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
